import { createFileRoute } from "@tanstack/react-router";

import { PraxaHistoryIndex } from "../components/praxa/PraxaHistorySurface";

export const Route = createFileRoute("/w/$workspaceId/")({
  component: PraxaWorkspaceIndexRoute,
});

function PraxaWorkspaceIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaHistoryIndex workspaceId={workspaceId} />;
}
